
import { MUTUAL_FUNDS } from "../actionTypes";
import {
    createUserMutualFundProfile, getUserMutualFundProfileList,
    deleteUserMutualFundProfile, mutualFundSearch, getUserMutualFundProfileDetails,
   
} from '../../apis';
import { MF_WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { _getMutualFundOrder, _cancelMutualFundOrder, _createMutualFundOrder, _createMutualFundSIPOrder, _createMutualFundSTPOrder, _createMutualFundSWPOrder, _createMutualFundSwitchOrder, _getMutualFundSIPOrder, _getMutualFundSummary, _getMutualFundHoldings, _getMutualFundMandateReport } from "../../controllers";
import { _getMutualFundNFOWatchlist, _registerMutualFundMandateReport } from "../../controllers/mutualFunds";

export const getMutualFund = (payload) => {
    return { type: MUTUAL_FUNDS.GET_MUTUALFUND, payload };
};

export const getMutualFundSideMenu = (payload) => {
    return { type: MUTUAL_FUNDS.GET_FILTERS, payload };
};

export const getMutualFundTypes = (payload) => {
    return { type: MUTUAL_FUNDS.GET_MUTUALFUND_TYPES, payload };
};

export const getThemes = (payload) => {
    return { type: MUTUAL_FUNDS.GET_THEMES, payload };
};
export const getorders = (payload) => {
    return { type: MUTUAL_FUNDS.GET_ORDERS, payload };
};
export const getWachlist = (payload) => {
    return { type: MUTUAL_FUNDS.GET_WACHLIST, payload: payload };
};

export const getFundOverview = (payload) => {
    return { type: MUTUAL_FUNDS.GET_FUND_OVERVIEW, payload };

};

// TODO: Remove once mutual funds get summary data structure fields are confirmed during API binding
export const getSummary = (payload) => {
    return { type: MUTUAL_FUNDS.GET_SUMMARY, payload };
};

export const getTransactionTypes = (payload) => {
    return { type: MUTUAL_FUNDS.GET_TRANSACTION_TYPES, payload };
};

export const getOrderTypes = (payload) => {
    return { type: MUTUAL_FUNDS.GET_ORDER_TYPES, payload };
};

export const updateActiveOrder = (activeOrder) => {
    return { type: MUTUAL_FUNDS.UPDATE_ACTIVE_ORDER, payload: activeOrder };
};


export const updateDefaultMutualFundWatchlist = () => async (dispatch, getState) => {
    //api call to get mutual funds watchlist 
    const objResp = await getUserMutualFundProfileList();

    if (objResp?.data?.data.UserDefinedProfiles?.length > 0) {
        // after getting finding default watchlist and fire api to send token for that partcilau watchlist 
        let defaultMutualFundWatchlist = objResp?.data?.data.UserDefinedProfiles?.find(eachMutualFundWatchlist => (eachMutualFundWatchlist?.is_default === 'Y'));
        if (defaultMutualFundWatchlist !== undefined) { //profile_id
            // after getting finding default watchlist and fire api to send token for that partcilau watchlist 
            const mutualFundWatchlistScripResponse = await getUserMutualFundProfileDetails(defaultMutualFundWatchlist?.profile_id);
            const mutualFundWatchList = {
                data: mutualFundWatchlistScripResponse?.data?.data,
                name: defaultMutualFundWatchlist?.profile_name,
                mutualFundProfile: defaultMutualFundWatchlist
            };
            // now assing data and update the mutualfundWatchlist
            dispatch(updateMutualFundWatchlist(mutualFundWatchList));//dispatch to update the watchlist
        }
    }

};

export const updateMutualFundWatchlist = (payload) => {
    return { type: MUTUAL_FUNDS.UPDATE_MUTUAL_FUND_WATCHLIST, payload };
};

export const createMutualFundProfile = (objcreateProfilePayload) => async (dispatch) => {
    const resp = await createUserMutualFundProfile(objcreateProfilePayload);
    dispatch(createMutualFundProfileSuccess(resp));
};

export const createMutualFundProfileSuccess = (resp) => {
    return { type: MUTUAL_FUNDS.CREATE_MUTUALFUND_PROFILE_SUCCESS, payload: resp };

};
export const createMutualFundProfileFailure = (payload) => {
    return { type: MUTUAL_FUNDS.CREATE_MUTUALFUND_PROFILE_FAILURE, payload };

};

export const getMutualFundProfileList = () => async (dispatch) => {
    const resp = await getUserMutualFundProfileList();
    dispatch(getMutualFundProfileListSuccess(resp));
};

export const getMutualFundProfileListSuccess = (resp) => {
    return { type: MUTUAL_FUNDS.GET_MUTUALFUND_PROFILE_LIST_SUCCESS, payload: resp };

};

export const getMutualFundProfileListFailure = (payload) => {
    return { type: MUTUAL_FUNDS.GET_MUTUALFUND_PROFILE_LIST_FAILURE, payload };

};

export const deleteMutualFundProfile = (profileId) => async (dispatch) => {
    const resp = await deleteUserMutualFundProfile(profileId);

};


export const deleteMutualFundProfileSuccess = (resp) => {
    return { type: MUTUAL_FUNDS.DELETE_MUTUALFUND_PROFILE_SUCCESS, payload: resp };
};

export const deleteMutualFundProfileFailure = (payload) => {
    return { type: MUTUAL_FUNDS.DELETE_MUTUALFUND_PROFILE_FAILURE, payload };
};

export const getMutualFundSearch = (objPayload) => async (dispatch) => {
    const resp = await mutualFundSearch(objPayload);
    dispatch(getMutualFundSearchSuccess(resp?.data?.data));
};

export const getMutualFundSearchSuccess = (resp) => {
    return { type: MUTUAL_FUNDS.GET_MUTUALFUND_SEARCH_SUCCESS, payload: resp };

};

export const getMutualFundSearchFailure = (payload) => {
    return { type: MUTUAL_FUNDS.GET_MUTUALFUND_SEARCH_FAILURE, payload };

};

export const getMutualFundProfileDetails = (payload) => async (dispatch) => {
    const profileId = 1;
    const resp = await getUserMutualFundProfileDetails(profileId);
    dispatch(getMutualFundProfileDetailsSuccess(resp));
};

export const getMutualFundProfileDetailsSuccess = (resp) => {
    return { type: MUTUAL_FUNDS.GET_MUTUALFUND_PROFILE_DETAILS_SUCCESS, payload: resp };

};

export const getMutualFundProfileDetailsFailure = (payload) => {
    return { type: MUTUAL_FUNDS.GET_MUTUALFUND_PROFILE_DETAILS_FAILURE, payload };

};

// Vinit R : 26-09-2023 :  Breeze - Mutual Funds - Start
// Mutual fund - GET orders
export const getMutualFundAllOrders = (payload) => async (dispatch) => {
    try {
        const resp = await _getMutualFundOrder(payload);
        dispatch(getMutualFundAllOrdersSuccess(resp));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(getMutualFundAllOrdersFailure(error?.response?.data));
        } else {
            dispatch(getMutualFundAllOrdersFailure({}));
        }
    }
};

export const getMutualFundAllOrdersSuccess = (resp) => {
    return { type: MUTUAL_FUNDS.GET_MUTUALFUND_ALL_ORDERS_SUCCESS, payload: resp };
};

export const getMutualFundAllOrdersFailure = (payload) => {
    return { type: MUTUAL_FUNDS.GET_MUTUALFUND_ALL_ORDERS_FAILURE, payload };
};

// Mutual funds - GET SIP orders
export const getMutualFundSIPOrders = (payload) => async (dispatch) => {
    try {
        const objResp = await _getMutualFundSIPOrder(payload);
        dispatch(getMutualFundSIPOrdersSuccess(objResp.data.data));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(getMutualFundSIPOrdersFailure(error?.response?.data));
        } else {
            dispatch(getMutualFundSIPOrdersFailure({}));
        }
    }
};

export const getMutualFundSIPOrdersSuccess = (payload) => {
    return { type: MUTUAL_FUNDS.GET_SYSTEMATIC_ORDERS_SUCCESS, payload };
};

export const getMutualFundSIPOrdersFailure = (payload) => {
    return { type: MUTUAL_FUNDS.GET_SYSTEMATIC_ORDERS_FAILURE, payload };
};

// Mutual fund - Create order
export const placeMutualFundOrder = (payload) => async (dispatch) => {
    try {
        const resp = await _createMutualFundOrder(payload);
        dispatch(placeUsermutualFundOrderSuccess(resp));
    } catch (error) {
        dispatch(placeUsermutualFundOrderFailure(error.message));
    }
};

export const placeUsermutualFundOrderSuccess = (resp) => {
    return { type: MUTUAL_FUNDS.PLACE_MUTUALFUND_ORDER_SUCCESS, payload: resp };
};

export const placeUsermutualFundOrderFailure = (payload) => {
    return { type: MUTUAL_FUNDS.PLACE_MUTUALFUND_ORDER_FAILURE, payload };
};

// Mutual fund - Create SIP order
export const placeMutualFundSIPOrder = (payload) => async (dispatch) => {
    try {
        const resp = await _createMutualFundSIPOrder(payload);
        dispatch(placeUsermutualFundSIPOrderSuccess(resp));
    } catch (error) {
        dispatch(placeUsermutualFundSIPOrderFailure(error.message));
    }
};

export const placeUsermutualFundSIPOrderSuccess = (resp) => {
    return { type: MUTUAL_FUNDS.PLACE_MUTUALFUND_SIP_ORDER_SUCCESS, payload: resp };
};

export const placeUsermutualFundSIPOrderFailure = (payload) => {
    return { type: MUTUAL_FUNDS.PLACE_MUTUALFUND_SIP_ORDER_FAILURE, payload };
};

// Mutual fund - Create STP order
export const placeMutualFundSTPOrder = (payload) => async (dispatch) => {
    try {
        const resp = await _createMutualFundSTPOrder(payload);
        dispatch(placeUsermutualFundSTPOrderSuccess(resp));
    } catch (error) {
        dispatch(placeUsermutualFundSTPOrderFailure(error.message));
    }
};

export const placeUsermutualFundSTPOrderSuccess = (resp) => {
    return { type: MUTUAL_FUNDS.PLACE_MUTUALFUND_STP_ORDER_SUCCESS, payload: resp };
};

export const placeUsermutualFundSTPOrderFailure = (payload) => {
    return { type: MUTUAL_FUNDS.PLACE_MUTUALFUND_STP_ORDER_FAILURE, payload };
};

// Mutual fund - Create SWP order
export const placeMutualFundSWPOrder = (payload) => async (dispatch) => {
    try {
        const resp = await _createMutualFundSWPOrder(payload);
        dispatch(placeUsermutualFundSWPOrderSuccess(resp));
    } catch (error) {
        dispatch(placeUsermutualFundSWPOrderFailure(error.message));
    }
};

export const placeUsermutualFundSWPOrderSuccess = (resp) => {
    return { type: MUTUAL_FUNDS.PLACE_MUTUALFUND_SWP_ORDER_SUCCESS, payload: resp };
};

export const placeUsermutualFundSWPOrderFailure = (payload) => {
    return { type: MUTUAL_FUNDS.PLACE_MUTUALFUND_SWP_ORDER_FAILURE, payload };
};

// Mutual fund - Create Switch order
export const placeMutualFundSwitchOrder = (payload) => async (dispatch) => {
    try {
        const resp = await _createMutualFundSwitchOrder(payload);
        dispatch(placeUsermutualFundSwitchOrderSuccess(resp));
    } catch (error) {
        dispatch(placeUsermutualFundSwitchOrderFailure(error.message));
    }
};

export const placeUsermutualFundSwitchOrderSuccess = (resp) => {
    return { type: MUTUAL_FUNDS.PLACE_MUTUALFUND_SWITCH_ORDER_SUCCESS, payload: resp };
};

export const placeUsermutualFundSwitchOrderFailure = (payload) => {
    return { type: MUTUAL_FUNDS.PLACE_MUTUALFUND_SWITCH_ORDER_FAILURE, payload };
};

// Mutual fund - Cancel order
export const cancelMutualFundOrder = (payload) => async (dispatch) => {
    try {
        const resp = await _cancelMutualFundOrder(payload);
        dispatch(cancelMutualFundOrderSuccess(resp));
    } catch (error) {
        dispatch(cancelMutualFundOrderFailure(error.message));
    }
};

export const cancelMutualFundOrderSuccess = (resp) => {
    return { type: MUTUAL_FUNDS.CANCEL_MUTUALFUND_ORDER_SUCCESS, payload: resp };
};

export const cancelMutualFundOrderFailure = (payload) => {
    return { type: MUTUAL_FUNDS.CANCEL_MUTUALFUND_ORDER_FAILURE, payload };
};

// Mutual fund - Portfolio summary 
export const getMutualFundSummaryData = (payload) => async (dispatch) => {
    try {
        const resp = await _getMutualFundSummary(payload);
        dispatch(getMutualFundSummarySuccess(resp?.data?.data));
    } catch (error) {
        console.log(error);
        dispatch(getMutualFundAllOrdersFailure(error.message));
    }
};

export const getMutualFundSummarySuccess = (resp) => {
    return { type: MUTUAL_FUNDS.GET_MUTUALFUND_SUMMARY_SUCCESS, payload: resp };
};

export const getMutualFundSummaryFailure = (payload) => {
    return { type: MUTUAL_FUNDS.GET_MUTUALFUND_SUMMARY_FAILURE, payload };
};

// Mutual funds - NFO 
export const getNfo = () => async (dispatch) => {
    try {
        const objResp = await _getMutualFundNFOWatchlist();
        dispatch(getNfoWatchlistSuccess(objResp?.data?.data?.CurrentNFO));
    } catch (error) {
        console.error(error);
        if (error?.response?.data) {
            dispatch(getNfoWatchlistFailure(error?.response?.data));
        } else {
            dispatch(getNfoWatchlistFailure([]));
        }
    }
};

export const getNfoWatchlistSuccess = (payload) => {
    return { type: MUTUAL_FUNDS.GET_NFO_SUCCESS, payload };
};

export const getNfoWatchlistFailure = (payload) => {
    return { type: MUTUAL_FUNDS.GET_NFO_FAILURE, payload };
};

// Mutual fund - Get mandate
export const getMandate = () => async (dispatch) => {
    try {
        const objResp = await _getMutualFundMandateReport();
        dispatch(getMandateSuccess(objResp.data.data));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(getMandateFailure(error?.response?.data));
        } else {
            dispatch(getMandateFailure({}));
        }
    }
};

export const getMandateSuccess = (payload) => {
    return { type: MUTUAL_FUNDS.GET_MANDATE_SUCCESS, payload };
};

export const getMandateFailure = (payload) => {
    return { type: MUTUAL_FUNDS.GET_MANDATE_FAILURE, payload };
};

// Mutual fund - Register mandate
export const registerMandate = () => async (dispatch) => {
    try {
        const objResp = await _registerMutualFundMandateReport();
        dispatch(registerMandateSuccess(objResp.data.data));
    } catch (error) {
        console.error(error.message);
        if (error?.response?.data) {
            dispatch(registerMandateFailure(error?.response?.data));
        } else {
            dispatch(registerMandateFailure({}));
        }
    }
};

export const registerMandateSuccess = (payload) => {
    return { type: MUTUAL_FUNDS.REGISTER_MANDATE_SUCCESS, payload };
};

export const registerMandateFailure = (payload) => {
    return { type: MUTUAL_FUNDS.REGISTER_MANDATE_FAILURE, payload };
};


export const getMutualFundHoldings = () => async (dispatch) => {
    try {
        const objResp = await _getMutualFundHoldings();
        dispatch(getMutualFundHoldingsSuccess(objResp.data.data?.SchemeWiseHolding));
    } catch (error) {
        console.error(error);
        if (error?.response?.data) {
            dispatch(getMutualFundHoldingsFailure(error?.response?.data));
        } else {
            dispatch(getMutualFundHoldingsFailure([]));
        }
    }
};

export const getMutualFundHoldingsSuccess = (payload) => {
    return { type: MUTUAL_FUNDS.GET_MUTUALFUND_HOLDINGS_SUCCESS, payload };
};

export const getMutualFundHoldingsFailure = (payload) => {
    return { type: MUTUAL_FUNDS.GET_MUTUALFUND_HOLDINGS_FAILURE, payload };
};
// Vinit R : 26-09-2023 :  Breeze - Mutual Funds - End

// MF watchlist column def

export const getMfColumnDef = () => async (dispatch) => {
    try {
        const objResp = [
            { headerName: '', colId: "check", hide: true, headerCheckboxSelection: true, 
             },
            { field: MF_WATCHLIST_GRID_INDEX.SYMBOL, headerName: 'SYMBOL', filter: 'agNumberColumnFilter' },
            { field: MF_WATCHLIST_GRID_INDEX.NAV, headerName: 'NAV', filter: 'agNumberColumnFilter', },
            { field: MF_WATCHLIST_GRID_INDEX.AUM, headerName: 'AUM', filter: 'agNumberColumnFilter' },
            { field: MF_WATCHLIST_GRID_INDEX.EXP_RATIO, headerName: 'EXP.RATIO', filter: 'agNumberColumnFilter' },
            { field: MF_WATCHLIST_GRID_INDEX.EXIT_LOAD, headerName: 'EXIT LOAD', filter: 'agNumberColumnFilter', },
            { field: MF_WATCHLIST_GRID_INDEX.MIN_INVESTMENT, headerName: 'MIN.INVESTMENT', filter: 'agNumberColumnFilter', },
            { field: MF_WATCHLIST_GRID_INDEX.CAGR, headerName: 'CAGR', filter: 'agNumberColumnFilter', },
        ];
        dispatch(columnDefSuccess(objResp));
    } catch (error) {
        console.log(error);
        dispatch(columnDefFailure([]));
    }
};
export const columnDefSuccess = (objResp) => {
    return { type: MUTUAL_FUNDS.GET_MF_COLUMNDEF_SUCCESS, payload: objResp };
};

export const columnDefFailure = (payload) => {
    return { type: MUTUAL_FUNDS.GET_MF_COLUMNDEF_FAILURE, payload };
};